import { Link } from "react-router-dom";
import { Hexagon } from "lucide-react";
import { LightboxImage } from "@/components/Lightbox";

export default function Footer() {
  return (
    <footer className="bg-forest-deep text-bone/70" data-testid="site-footer">
      <div className="max-w-5xl mx-auto px-6 md:px-10 pt-14 md:pt-16">
        <LightboxImage
          src="/assets/brand/banner.webp"
          alt="ApiaryKeeper — Manage. Track. Thrive."
          testid="footer-brand-banner"
          className="w-full h-auto rounded-2xl"
        />
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="flex items-center gap-2.5 mb-5">
              <Hexagon className="w-7 h-7 text-honey" strokeWidth={1.5} />
              <span className="font-display text-2xl font-semibold text-bone">ApiaryKeeper</span>
            </div>
            <p className="text-sm leading-relaxed max-w-sm">
              A calmer, smarter way to keep your hive records. Built by beekeepers,
              for beekeepers of every experience level.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-honey mb-4">Explore</p>
            <div className="flex flex-col gap-2.5 text-sm">
              <Link to="/features" data-testid="footer-link-features" className="hover:text-honey transition-colors duration-300">Features</Link>
              <Link to="/pricing" data-testid="footer-link-pricing" className="hover:text-honey transition-colors duration-300">Pricing</Link>
              <Link to="/pre-register" data-testid="footer-link-pre-register" className="hover:text-honey transition-colors duration-300">Pre-Register</Link>
              <Link to="/founding-keepers" data-testid="footer-link-founding-keepers" className="hover:text-honey transition-colors duration-300">Founding Keepers Hall</Link>
              <Link to="/faq" data-testid="footer-link-faq" className="hover:text-honey transition-colors duration-300">FAQ</Link>
              <Link to="/tips" data-testid="footer-link-tips" className="hover:text-honey transition-colors duration-300">Beekeeping Tips</Link>
              <Link to="/privacy" data-testid="footer-link-privacy" className="hover:text-honey transition-colors duration-300">Privacy Policy</Link>
              <Link to="/terms" data-testid="footer-link-terms" className="hover:text-honey transition-colors duration-300">Terms of Service</Link>
            </div>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-honey mb-4">Company</p>
            <p className="text-sm leading-relaxed">
              A product of Herrell Interactive<br />
              Herrell Homestead LLC
            </p>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-bone/10 flex flex-col md:flex-row justify-between gap-3 text-xs text-bone/40">
          <span data-testid="footer-copyright">© {new Date().getFullYear()} Herrell Homestead LLC. All rights reserved.</span>
          <span>apiarykeeper.com</span>
        </div>
      </div>
    </footer>
  );
}
